import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/components/MainLayout'

// 基础数据管理模块
const ProcessList = () => import('@/views/basic-data/ProcessList')
const Supplier = () => import('@/views/basic-data/Supplier')
const SupplierRole = () => import('@/views/basic-data/SupplierRole')

// 询报价管理模块
const Inquiry = () => import('@/views/quotation/Inquiry')
const Quotation = () => import('@/views/quotation/Quotation')
const Negotiation = () => import('@/views/quotation/Negotiation')
const QuotationReport = () => import('@/views/quotation/QuotationReport')
const WinningBid = () => import('@/views/quotation/WinningBid')
const FileManagement = () => import('@/views/quotation/FileManagement')

// 生产监控模块
const ProgressBoard = () => import('@/views/production/ProgressBoard')
const ProgressAlert = () => import('@/views/production/ProgressAlert')

// 报表分析模块
const SupplierKPI = () => import('@/views/report/SupplierKPI')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        // 基础数据管理
        {
          path: 'process-list',
          name: 'ProcessList',
          component: ProcessList,
          meta: { title: '工序清单管理' }
        },
        {
          path: 'supplier',
          name: 'Supplier',
          component: Supplier,
          meta: { title: '供应商管理' }
        },
        {
          path: 'supplier-role',
          name: 'SupplierRole',
          component: SupplierRole,
          meta: { title: '供应商角色与权限' }
        },

        // 询报价管理
        {
          path: 'inquiry',
          name: 'Inquiry',
          component: Inquiry,
          meta: { title: '询价管理' }
        },
        {
          path: 'quotation',
          name: 'Quotation',
          component: Quotation,
          meta: { title: '报价管理' }
        },
        {
          path: 'negotiation',
          name: 'Negotiation',
          component: Negotiation,
          meta: { title: '在线议价' }
        },
        {
          path: 'quotation-report',
          name: 'QuotationReport',
          component: QuotationReport,
          meta: { title: '报价单报表' }
        },
        {
          path: 'winning-bid',
          name: 'WinningBid',
          component: WinningBid,
          meta: { title: '中标管理' }
        },
        {
          path: 'file-management',
          name: 'FileManagement',
          component: FileManagement,
          meta: { title: '文件管理' }
        },

        // 生产监控
        {
          path: 'progress-board',
          name: 'ProgressBoard',
          component: ProgressBoard,
          meta: { title: '实时进度看板' }
        },
        {
          path: 'progress-alert',
          name: 'ProgressAlert',
          component: ProgressAlert,
          meta: { title: '工序级进度通知与预警' }
        },

        // 报表分析
        {
          path: 'supplier-kpi',
          name: 'SupplierKPI',
          component: SupplierKPI,
          meta: { title: 'KPI看板' }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js